import UserType from 'constants/user';
import HomeCustomer from 'containers/homeScreen/home_customer';
import HomeStylist from 'containers/homeScreen/home_stylist';
import HomeWaiting from 'containers/homeScreen/home_waiting';
import { useAuth } from 'contexts/AuthContext';
import { isProductionServer } from '../firebase';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { globalActions } from 'redux/global/global.slice';
import { RootState } from 'redux/store';
import { PATH } from './constant';
import { UserQuizStatus } from 'containers/quiz_manager';
import utils from '../utils/utils';

export default function DashboardRouter({ component: Component, ...rest }) {
    const defaultWidgetPath = useSelector((state: RootState) => state.widget.store?.defaultPagePath);
    const { currentUser } = useAuth();
    const user = useSelector((state: RootState) => state.userDetail.me);
    const pendingQuizzes = useSelector((state: RootState) => state.userDetail.pendingQuizzes);
    const isPendingQuizzes =
        pendingQuizzes?.hasOwnProperty('getPendingQuizzes') &&
        pendingQuizzes?.getPendingQuizzes?.quizConfigs?.filter((item) => item.status === UserQuizStatus.pending)
            ?.length;
    const from = JSON.parse(sessionStorage.getItem('from') || '{}');

    const approvedState = useSelector((state: RootState) => state.authentication.approved);
    const dispatch = useDispatch();
    const spinnerLoading = useSelector((state: RootState) => state.global.spinnerLoading);

    const checkStoredLink = (PrefferedComponent) => {
        if (from?.from?.pathname) {
            sessionStorage.removeItem('from');
            setTimeout(() => {
                dispatch(globalActions.setSpinnerLoading(spinnerLoading.filter((item) => item !== 'loadingHome')));
            }, 2000);
            return (
                <Redirect
                    to={{
                        pathname: from?.from?.pathname,
                        search: from?.from?.search,
                    }}
                />
            );
        } else {
            return <PrefferedComponent />;
        }
    };
    const getDashboard = (props) => {
        let { location } = props;
        if (user) {
            if (user.userType === UserType.Customer) {
                if (isPendingQuizzes === 0) {
                    return checkStoredLink(HomeCustomer);
                } else {
                    return (
                        <Redirect
                            to={{
                                pathname: PATH.QUIZ_MANAGER,
                                state: { from: location },
                            }}
                        />
                    );
                }
            } else if ((false && user.userType === UserType.Stylist && isProductionServer) || !approvedState) {
                return <HomeWaiting />;
            } else {
                return checkStoredLink(HomeStylist);
            }
        }
    };

    return (
        <Route
            {...rest}
            render={(props) => {
                let { location } = props;

                return currentUser && user ? (
                    getDashboard(props)
                ) : (
                    <Redirect
                        to={{
                            pathname: utils.isAppInWidgetMode()
                                ? !user && defaultWidgetPath
                                    ? defaultWidgetPath
                                    : PATH.SIGNUP_CUSTOMER
                                : PATH.LOGIN,
                            state: { from: location },
                        }}
                    />
                );
            }}
        />
    );
}
